import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputUserAssignedLicense<T extends EMode = EMode.entity> {
  /** Alias: assigned */
  assigned?: any;
  /** Alias: license */
  license?: any;

  __typename?: string;
}

const fields: FieldDefinitions<InputUserAssignedLicense> = {
  assigned: {
    alias: 'assigned',
  },
  license: {
    alias: 'license',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputUserAssignedLicenseEntityDefinition: EntitiyDefinition<InputUserAssignedLicense> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputUserAssignedLicense',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
